import { ProjectOrTaskType } from '../../../shared/data-types/status-types';

export class StatusModel {
  public id = null;
  public name = '';
  public group: ProjectOrTaskType = null;
}
